export default "__VITE_ASSET__B_G9j4o7__"